// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hidden-input{visibility:hidden;position:absolute;width:1px;left:0}.clipper{max-width:700px}.clipper,.clipper .vuejs-clipper-basic__padding,.clipper canvas{max-height:85vh}.no-pointer{pointer-events:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
